import { makeStyles } from '@branchjs/neo-components';

export const useStyles = makeStyles((theme) => ({
  card: {
    width: '520px',
    minHeight: '378px',
    borderRadius: '8px',
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    margin: `${theme.spacing(4)}px ${theme.spacing(6)}px ${theme.spacing(7)}px`,
  },
  image: {
    width: '177px',
    height: '122px',
    margin: '36px auto 0',
  },
  subTitle: {
    marginTop: theme.spacing(3),
  },
  message: {
    marginTop: theme.spacing(0.5),
  },
  button: {
    marginTop: theme.spacing(3),
  },
  loading: {
    margin: 'auto',
  },
  footer: {
    margin: `${theme.spacing(3)}px 0 0 0`,
  },
}));
